import React from 'react'

import { useForm } from 'react-hook-form'

const Memberpop = (props) => {
  const { next, previous } = props
  const { handleSubmit, register, errors } = useForm()
  return (
    <div className='container px-5 pt-5 custom-modal'>
      <div className='row'>
        <h3 className='px-3'>
          Become an eksplode! Member{' '}
        </h3>
      </div>
      <br />
      <div className='row px-3'>
        <h6>
          Please confirm that you have read, understood, and agree to each and
          every term and condition set forth on our Member Agreement form by
          entering your full name and your age here:
        </h6>
      </div>

      <div className='form-row mr-3'>
        <div className='col-md-6'>
          <label htmlFor='full_name'>Full Name</label>
          <input
            type='text'
            className='form-control mb-0 '
            id='full_name'
            name='full_name'
            ref={register({
              required: {
                value: true,
                message: 'This Field is Required',
              },
            })}
          />
          <label htmlFor='full_name' className='error'>
            {errors.full_name && errors.full_name.message}
          </label>
        </div>
        <div className='col-md-6'>
          <label htmlFor='age'>Age</label>
          <input
            type='text'
            className='form-control mb-0'
            id='age'
            name='age'
            ref={register({
              required: {
                value: true,
                message: 'This Field is Required',
              },
            })}
          />
          <label htmlFor='age' className='error'>
            {errors.age && errors.age.message}
          </label>
        </div>
      </div>

      <div className='row d-flex flex-column px-3'>
        <div className='d-flex justify-content-start mt-3 align-items-center'>
          <input
            type='checkbox'
            className='form-control w-auto mr-3'
            id='read'
            name='read'
            ref={register({
              required: {
                value: true,
                message: 'Please read the guidelines',
              },
            })}
          />
          <p className='mb-0'>I have read the guidelines</p>
        </div>
        <label htmlFor='read' className='error mt-2'>
          {errors.read && errors.read.message}
        </label>
      </div>
      <div className='row mt-3 justify-content-center'>
        <button
          className='btn btn-solid mx-1'
          style={{ minWidth: '150px' }}
          onClick={previous}
        >
          Previous
        </button>
        <button
          className='btn btn-solid mx-1'
          style={{ minWidth: '150px' }}
          onClick={handleSubmit(next)}
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default Memberpop
